import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Cuohao = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4e4__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4e4__a)">
            <path
              fillRule="evenodd"
              d="M21.172 24 9.845 12.673c-.781-.781-.758-2.045.023-2.826a1.99 1.99 0 0 1 2.805-.002L24 21.172 35.327 9.845c.781-.781 2-.802 2.781-.021l.024.023c.78.781.804 2.045.023 2.826L26.828 24l11.327 11.327c.781.781.758 2.045-.023 2.826a1.99 1.99 0 0 1-2.805.002L24 26.828 12.673 38.155c-.781.781-2.045.758-2.826-.023l-.023-.024c-.781-.78-.76-2 .02-2.781L21.173 24Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
